import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Client as WebSocket } from "rpc-websockets";

import { Link } from "react-router-dom";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import Card from "@mui/material/Card";

import CardContent from "@mui/material/CardContent";
import { default as Spinner } from "../components/Spinner";
import { getURLAPI } from "../utils/getURL";

let location;
let pathname;
let search;

const OnePage = () => {
  //  const body = useSelector((state) => state.app.body);

  location = useLocation();
  pathname = location.pathname.split("/")[1];
  search = location.search.split("?")[1];
  if (pathname === "") {
    pathname = search || "";
  }

  const auth = useContext(AuthContext);
  //pathname = window.location.href; //props.
  //https://fc.ahis.online/?QweRtY
  const config = auth.config;
  let reference = auth.Customer && auth.Customer.reference;

  let maxWidth = "65em";
  let KodReg = "";
  //const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [Kod, setKod] = React.useState("");

  const openHandle = async () => {
    pathname = location.pathname.split("/")[1];
    search = location.search.split("?")[1];
    if (pathname === "") {
      pathname = search || "";
    }

    let reference = pathname + KodReg; // location.pathname.split("/")[1];
    //      let URLAPI = getURLAPI(config)
    let Options = { reference };
    //
    let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

    const data1 = await wssrequest(Options, URL_WS);

    //async
  };

  const wssrequest = useCallback(async (options = null, URL_WS = null) => {
    //setLoading(true);
    try {
      //URL_WS = 'wss://shop.pegas-sk.com.ua:8043'

      let ws_client = new WebSocket(URL_WS);

      ws_client.on("close", function () {
        console.log("event : ws_client close !!!");
      });
      ws_client.on("error", (error) => {
        console.log("ws_client error", error);
      });

      let ready = ws_client.ready;

      console.log("!!!ws_client.ready = ", ready);
      await ws_client.on("open", async function () {
        // login your client to be able to use protected methods
        ws_client
          .login(options)
          .then(function (result) {
            //console.log('read from table Users where login passw : ', result)
            /*
                  if (result.status === 200) {
                    auth.login(result.data.token, result.data.userId)
                  } else if (result.status === 400) {
                    //err
                    console.log('ERR login : ', result)
                    setError(result.message)
                  }
      */

            //let options = { ...form }
            let tableName = "ChangeCustomers";
            let action = { metod: "reference" };
            //read from table UnitTypes, where  id=1
            ws_client
              .call("Model_read", { tableName, where: options, action })
              .then(function ({ tableName, result }) {
                //console.log('read from table Users where login passw : ',result)
                if (result.status === 200) {
                  auth.login(
                    result.data.token,
                    result.data.userId,
                    result.data.reference
                  );
                  auth.setCustomer(result.data.customer);
                  auth.setStoreTypes(result.data.types);
                } else if (result.status === 400) {
                  //err
                  //setError(result.message);
                }
              })
              .catch(function (error) {
                console.log("err", error);
                //setError(error);
              });

            //setLoading(false);
          })
          .catch(function (error) {
            console.log("auth failed - error : ", error);
            //setLoading(false);
            //setError(error);
          });
      });
    } catch (error) {
      console.log(error);
      //setLoading(false);
      //setError(error);
    }
  });

  const handleClose = () => {
    setOpenDialog(false);
  };

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  function GetDialog(props) {
    return (
      <>
        {/* Alert Dialog */}
        <Dialog
          open={openDialog}
          maxWidth={maxWidth}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: async (event) => {
              event.preventDefault();
              //const formData = new FormData(event.currentTarget);
              //const formJson = Object.fromEntries(formData.entries());

              //let KodReg = body.kodreg;
              //let currentURL = window.location.href;
              //window.location.href = currentURL + KodReg;
              console.log("KODREG=", KodReg);
              openHandle();
              KodReg = "";
              handleClose();
            },
          }}
        >
          <DialogTitle
            style={{
              fontSize: "1.60rem",
            }}
          >
            {"Введіть КОД для реєстрації"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>* код для реєстрації надсилається Вам персонально</div>
            </DialogContentText>
            <TextField
              id="outlined-basic"
              label={"Введіть КОД"} //"Тип работ"
              //variant="standard"
              variant="outlined"
              style={{
                //marginBottom: 15,
                //marginLeft: 20,
                width: "100%",
                //display: 'flex',
                //justifyContent: 'space-between',
              }}
              //value={(SelectedManager && SelectedManager.name) || ""}
              onChange={(item) => {
                KodReg = item.target.value;
                /*    dispatch({
                  type: "fetch/get_add", //'fetch/get_add',
                  payload: item.target.value,
                  ob: "kodreg",
                });*/
                //setKod(item.target.value);
              }}
            ></TextField>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              as={Link}
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              to={{
                pathname: KodReg,
              }}
              state={{
                kod: KodReg,
              }}
              onClick={() => {
                openHandle();
                //let currentURL = window.location.href;
                //console.log("KODREG=", KodReg);
                //window.location.href = currentURL + KodReg;
                KodReg = "";
                handleClose();
              }}
              variant="contained"
              type="submit"
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  const ready = () => {
    if (true)
      //doctors_item /* && calendars*/ || true)
      // || !(worker2 && worker2.value))
      return true;
    else return false;
  };

  return (
    <>
      {ready() && (
        <>
          <Box style={{}}>
            <Card
              style={{
                borderRadius: 10,
                marginTop: 10,
                backgroundColor: "#00ff921a",
              }}
            >
              <CardContent>
                <div>
                  <p>
                    <span style={{ fontWeight: 400 }}>
                      ЗРУЧНЕ ТА БЕЗПЕЧНЕ ПІДПИСАННЯ ДОКУМЕНТІВ ОНЛАЙН
                    </span>
                  </p>

                  <p>
                    <span style={{ fontWeight: 800 }}>Шановні партнери!</span>
                  </p>

                  <p>
                    <span>
                      Компанія ТОВ &quot;ФРІАННА ФУДЗ&quot; переходить на новий
                      рівень взаємодії — впровадження{" "}
                      <span style={{ fontWeight: 700 }}>
                        електронне підписання договорів та супровідних
                        документів.
                      </span>
                    </span>
                  </p>

                  <p>
                    <span></span>
                  </p>

                  <p>
                    <span>Це швидко, надійно та офіційно!</span>
                  </p>

                  <p>
                    <span>&#10004;</span>
                    &#65039;
                    <span>Не потрібно друкувати та надсилати папери</span>
                  </p>

                  <p>
                    <span>&#10004;</span>
                    &#65039;
                    <span>Підписання займає лише кілька хвилин</span>
                  </p>

                  <p>
                    <span>&#10004;</span>
                    &#65039;
                    <span>
                      Усі документи зберігаються в захищеному електронному
                      архіві
                    </span>
                  </p>

                  <p>
                    <span>&#10004;</span>
                    &#65039;
                    <span>Відповідає вимогам законодавства України</span>
                  </p>

                  <p>
                    <span></span>
                  </p>

                  <p>
                    <span>&#128206;</span>
                    <span>
                      Ви можете переглядати, заповнювати та підписувати
                      документи в особистому кабінеті за посиланням, яке ми вам
                      надсилаємо.
                    </span>
                  </p>

                  <p>
                    <span></span>
                  </p>

                  <p>
                    <span>&#128161;</span>
                    <span style={{ fontWeight: 700 }}>
                      Чому варто скористатися електронним підписом вже зараз
                    </span>
                  </p>

                  <p>
                    <span></span>
                  </p>

                  <p>
                    <span>
                      * Це <span style={{ fontWeight: 700 }}>зручно</span> –
                      доступ з будь-якого пристрою
                    </span>
                  </p>

                  <p>
                    <span>
                      * Це <span style={{ fontWeight: 700 }}>економно</span> –
                      без витрат на папір та доставку
                    </span>
                  </p>

                  <p>
                    <span>
                      * Це <span style={{ fontWeight: 700 }}>оперативно</span> –
                      процес займає кілька кліків
                    </span>
                  </p>

                  <p>
                    <span></span>
                  </p>

                  <p>
                    <span style={{ fontWeight: 700 }}>
                      Разом робимо бізнес ефективнішим!
                    </span>
                  </p>

                  <p>
                    <span>
                      Якщо у вас виникли запитання або потрібна допомога – наша
                      команда завжди готова підтримати вас.
                    </span>
                  </p>
                  <Button
                    //as={Link}
                    sx={{
                      ml: 1,
                      alignItems: "center",
                      "&:hover": {
                        backgroundColor: "primary.light",
                        //backgroundColor: 'primary.dark',
                        opacity: [0.9, 0.8, 0.7],
                      },
                    }}
                    variant="contained"
                    //style={{ marginBottom: 5 }}

                    //to={{
                    //  pathname: "/pages/manager/item",
                    //}}
                    //state={{
                    //  id: cell.row.original.manager.id, //cell.row.original['worktime_id'],
                    //}}
                    onClick={() => {
                      setOpenDialog(true);
                    }}
                  >
                    Реєстрація
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Box>
          {/* Get Dialog */}
          <GetDialog />
        </>
      )}
      {!ready() && (
        <>
          <Box maxWidth={"65em"}>
            <Card>
              <CardContent>
                <Spinner />
              </CardContent>
            </Card>
          </Box>
        </>
      )}
    </>
  );
};

export default OnePage;
